module.exports = __webpack_public_path__ + "img/logo-nasa.43581823.svg";